/**
 * Подпись даты словами экрана: «сегодня» · «вчера» · «16.09.2026».
 *
 * ⛔⛔ ЭТО ВТОРОЕ МЕСТО ОДНОГО ПРАВИЛА, И Я НАЗЫВАЮ ЭТО ВСЛУХ.
 *
 * Первое живёт внутри `features/obrashcheniya/components/Razbor.tsx` и наружу
 * не выведено (функция там внутренняя). Экран обращений в этой сессии
 * править нельзя — рамка рунбука `s608`: файлы экрана общие с панелью, и
 * правка ради лайта означала бы чинить чужой экран.
 *
 * Пока правила два, они разойдутся: поправят «вчера» в одном — второе
 * промолчит. Развилка вынесена владельцу отдельной строкой: свести в один
 * файл и позвать оттуда оба места. До её решения — здесь ДОСЛОВНО та же
 * логика и ТЕ ЖЕ ключи словаря, чтобы расхождение не завелось само.
 *
 * ⛔ Сырой вид даты («2026-09-18») на экране — дефект §31: экран говорит
 * языком салона. Именно он и был пойман глазом на первом прогоне панели.
 */
export function podpisDaty(
  iso: string,
  text: (k: string, v?: Record<string, string | number>) => string,
): string {
  const segodnya = new Date();
  const vchera = new Date(segodnya.getTime() - 86_400_000);
  const den = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

  if (iso === den(segodnya)) return text('obrashcheniya.segodnya');
  if (iso === den(vchera)) return text('obrashcheniya.vchera');

  const [g, m, d] = iso.split('-');

  return `${d}.${m}.${g}`;
}
